import { Model } from "pinia-orm";
import CompanyProjectRole from "./CompanyProjectRole";
import Project from "./Project";

export default class Company extends Model {
  static name = "Company";
  static entity = "companys";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(),
      createdAt: this.attr(),
      updatedAt: this.attr(),
      title: this.attr(""),
      socReason: this.attr(),
      address: this.attr(""),
      postalCode: this.attr(""),
      city: this.attr(""),
      cedex: this.attr(""),
      phoneNumber: this.attr(""),
      fax: this.attr(""),
      email: this.attr(""),
      national: this.attr(),
      siren: this.attr(""),
      nic: this.attr(""),
      batchUuid: this.attr(""),
      projects: this.belongsToMany(
        Project,
        CompanyProjectRole,
        "companyId",
        "projectId",
        "uuid",
        "uuid",
      ),
    };
  }
}
